import * as types from './mutation-types'

export const loadTimezones = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/timezones').then((response) => {
            commit(types.ADD_TIMEZONES, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}